module.exports = __webpack_public_path__ + "img/益视说明书_11.56449c73.png";